import { render, staticRenderFns } from "./game.vue?vue&type=template&id=650c1e65&"
import script from "./game.vue?vue&type=script&lang=ts&"
export * from "./game.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports